var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_filter",
    d: "M6.833,6A.841.841,0,0,0,6,6.833v1.03a2.5,2.5,0,0,0,.953,1.964l3.38,2.663V17.5a.5.5,0,0,0,.79.407l2.333-1.667a.5.5,0,0,0,.21-.407V12.49l3.38-2.663A2.5,2.5,0,0,0,18,7.863V6.833A.841.841,0,0,0,17.167,6ZM7,7H17v.863a1.5,1.5,0,0,1-.572,1.178L13.1,11.667H10.9L7.572,9.041A1.5,1.5,0,0,1,7,7.863Zm4.333,5.667h1.333v2.91l-1.333.952Z",
    transform: "translate(-6 -6)",
    fill: "#070707"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/iconFilter.a2b9cb4b0391f0ee19b2c409935ed939.svg";
export { ForwardRef as ReactComponent };